import {ApiTags, createBaseApi} from "../../config";
import {contentServices} from "./content.services";
import {
    IPageResponse,
    IPagination,
    IRelatedResponse,
    ITypePage,
    IDataResponse,
    CategoryResponse, IProfileList, IPageContentResponse, IContentByRoleParams
} from "./content.interfaces";
import {IGenreContent} from "../user";
import {IData} from "../../../components/Cards/types";

export const contentQueries = createBaseApi("contentApi").injectEndpoints({
    endpoints: (builder) => ({
        fetchCategoriesRequest: builder.query<CategoryResponse[], ITypePage>({
            query: (params) => contentServices.fetchCategoriesRequest(params)
        }),
        getPage: builder.query<IPageResponse[], ITypePage>({
            query: (params) => contentServices.getPage(params)
        }),
        getPageResults: builder.query<IPageContentResponse, ITypePage>({
            query: (params) => contentServices.getPageResults(params)
        }),
        getAllContent: builder.query<IPageContentResponse, ITypePage>({
            query: (params) => contentServices.getAllContent(params)
        }),
        getPageContent: builder.query<IPageContentResponse, ITypePage>({
            query: (params) => contentServices.getPageContent(params)
        }),
        getNearbyEvents: builder.query<IPageContentResponse, ITypePage>({
            query: (params) => contentServices.getNearbyEvents(params)
        }),
        getGenreContent: builder.query<IPageContentResponse, IGenreContent>({
            query: (params) => contentServices.getGenreContent(params)
        }),
        getContentDetails: builder.query<IDataResponse, IContentByRoleParams>({
            query: (params) => contentServices.getContentDetails(params),
            providesTags: (_result, _error, params) => [
                {type: ApiTags.VIDEO, id: String(params.id)},
            ],
        }),
        getRelatedContent: builder.query<Partial<IRelatedResponse[] | IData[] | IProfileList[]>, IContentByRoleParams>({
            query: (params) => contentServices.getRelatedContent(params)
        }),
        getSearchPage: builder.query<IRelatedResponse[], IPagination>({
            query: (params) => contentServices.getSearchPage(params)
        }),
    }),
})

export const {
    useFetchCategoriesRequestQuery,
    useGetPageQuery,
    useGetPageResultsQuery,
    useLazyGetAllContentQuery,
    useLazyGetPageContentQuery,
    useLazyGetNearbyEventsQuery,
    useLazyGetGenreContentQuery,
    useGetPageContentQuery,
    useGetContentDetailsQuery,
    useLazyGetContentDetailsQuery,
    useGetRelatedContentQuery,
    useGetSearchPageQuery,

} = contentQueries
